import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Kitchen Screen Items
export const getKitchenItemsScreen = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/kitchen/items/screen", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: {
          "6": [ { id, order_id, product, status, ... } ],
          "7": [ ... ]
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Change Kitchen Items Status
export const changeKitchenItemsStatus = async (ids, status = "pickup") => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  const normalizedIds = Array.isArray(ids) ? ids.filter(Boolean) : [];

  try {
    const res = await api.post(
      "/kitchen/change/items/status",
      {
        ids: normalizedIds,
        status,
      },
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        success: true,
        message: "Order items updated successfully"
      }

      supported status values:
      - in_prepration
      - pending
      - pickup
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Public Orders In Kitchen
export const getPublicKitchenOrders = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/public/orders/in/kitchen", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: [],
        message: "تم جلب العناصر بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
